import { Directive, HostBinding, inject, Input } from '@angular/core';
import { BreakpointService } from '@big-direkt/utils/shared';

@Directive({
    selector: 'td[bigUiTableCell]',
})
export class TableCellDirective {
    private readonly breakpointService = inject(BreakpointService);

    @Input() public renderResponsive?: boolean;
    @Input() public noPadding = false;

    @HostBinding('class') public get classList(): string {
        const isMobile = this.breakpointService.isMobile();
        const classes = [
            'align-top',
            'group-odd/row:bg-gray-400',
            'light:group-even/row:bg-white',
            'dark:group-odd/row:bg-dark-contrast',
            'border-r-2 last:border-r-0',
            'group-odd/row:border-r-white group-even/row:border-r-gray-400 print/row:border-r-gray-400!',
            'dark:group-odd/row:border-r-gray-800 dark:group-even/row:border-r-dark-background',
        ];

        if (!this.noPadding) {
            classes.push('p-3');
        }

        if (isMobile && this.renderResponsive) {
            classes.push('block border-b-2 border-b-white');
        }

        return classes.join(' ');
    }
}
